/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Body_Measures_Site_HipsInputs */

const en_us2_body_measures_site_hips = /** @type {(inputs: Body_Measures_Site_HipsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hips`)
};

const pt_br2_body_measures_site_hips = /** @type {(inputs: Body_Measures_Site_HipsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quadril`)
};

const es_419_body_measures_site_hips = /** @type {(inputs: Body_Measures_Site_HipsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cadera`)
};

const pt_pt2_body_measures_site_hips = /** @type {(inputs: Body_Measures_Site_HipsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anca`)
};

const fr_fr2_body_measures_site_hips = /** @type {(inputs: Body_Measures_Site_HipsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hanches`)
};

const de_de2_body_measures_site_hips = /** @type {(inputs: Body_Measures_Site_HipsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hüfte`)
};

const it_it2_body_measures_site_hips = /** @type {(inputs: Body_Measures_Site_HipsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fianchi`)
};

/**
* | output |
* | --- |
* | "Hips" |
*
* @param {Body_Measures_Site_HipsInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const body_measures_site_hips = /** @type {((inputs?: Body_Measures_Site_HipsInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Body_Measures_Site_HipsInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_body_measures_site_hips(inputs)
	if (locale === "es-419") return es_419_body_measures_site_hips(inputs)
	if (locale === "pt-PT") return pt_pt2_body_measures_site_hips(inputs)
	if (locale === "fr-FR") return fr_fr2_body_measures_site_hips(inputs)
	if (locale === "de-DE") return de_de2_body_measures_site_hips(inputs)
	if (locale === "it-IT") return it_it2_body_measures_site_hips(inputs)
	return en_us2_body_measures_site_hips(inputs)
});
export { body_measures_site_hips as "body-measures.site_hips" }